import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  parent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'calc(100% - 48.13%)',
  },
  icon: {
    color: theme.palette.labraCheckbox.main,
    '&.MuiSvgIcon-root': {
      fontSize: '40px',
    },
    marginBottom: theme.spacing(0.875),
  },
  offerAcceptedTitle: {
    color: theme.palette.text.secondary,
    fontSize: '18px',
    fontWeight: 600,
    marginBottom: theme.spacing(3),
  },
  offerAcceptedContent: {
    fontSize: '14px',
    color: theme.palette.text.secondary,
    width: '58%',
  },
}))
